import { OPEN_MODAL, CLOSE_MODAL } from '../actions';

const initialState = {
  type: '',
  modalProps: {},
};

export const modalContainer = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_MODAL:
      return {
        ...state,
        type: action.payload.type,
        modalProps: action.payload.modalProps || {},
      };

    case CLOSE_MODAL:
      return initialState;

    default:
      return state;
  }
};
